import { Typography, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import { CoBrowseContext } from "../../../../store/coBrowse.context";
import IMessage from "../../../../interface/IMessage";
import { AppContext } from "../../../../store/genesys.context";
import ICoBrowseDto from "../../../../interface/ICoBrowseDto";

const NavigationOffer = (): React.JSX.Element => {
  const {
    allowNavigation,
    declineNavigation,
    coBrowseDto,
  }: {
    allowNavigation: () => void;
    declineNavigation: () => void;
    coBrowseDto: ICoBrowseDto;
  } = React.useContext(CoBrowseContext);

  const {
    getAgentName,
    getLastAgentMessage,
  }: {
    getAgentName: (message: IMessage) => string;
    getLastAgentMessage: () => IMessage;
  } = React.useContext(AppContext);

  return (
    <Grid
      container
      spacing={2}
      sx={{
        mt: "10px",
      }}
    >
      <Grid
        size={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <Typography variant="body1" color="initial">
          {getAgentName(getLastAgentMessage())} möchte eine andere Seite öffnen
        </Typography>
      </Grid>

      <Grid
        size={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
        }}
      >
        <Button variant="contained" color="primary" onClick={allowNavigation}>
          Erlauben
        </Button>

        <Button variant="outlined" color="primary" onClick={declineNavigation}>
          Ablehnen
        </Button>
      </Grid>
      <Grid
        size={12}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <Typography variant="body1" color="initial">
          <b>Hinweis:</b> Wenn Sie die Navigation erlauben, wird die Seite{" "}
          <b>{coBrowseDto.navigation.url}</b> in einem neuen Tab geöffnet.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default NavigationOffer;
